import api from 'api';
import { useReduxState } from 'hooks';
import { ConfirmButton } from 'components/common';

import type { ApiDataHookUpdateHandler } from 'lib/api/useApiData';
import type { ShareUser } from './Share';

interface Props {
  targetUser: ShareUser;
  updateCourse: () => Promise<void>;
  updateUsers: ApiDataHookUpdateHandler;
}

const ShareUsersRemove = ({ targetUser, updateCourse, updateUsers }: Props) => {
  const {
    messages,
    pageState: { course }
  } = useReduxState();

  const removeUser = async () => {
    const url = `/admin/courses/${course.id}/users?UserId=${targetUser.id}`;
    const response = await api.delete(url);
    if (!response.data || !response.data.success) return false;
    await updateUsers({});
    await updateCourse();
    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={messages.shareRemoveFromCourse}
      category="danger"
      confirmText={messages.shareRemoveUserConfirm}
      confirmTitle={messages.shareRemoveUserFromCourse}
      onConfirm={removeUser}
      successMessage={messages.commonRemoveUserSuccess}
    />
  );
};

export default ShareUsersRemove;
